import {environment} from "../../environments/environment";

export default class ApiEndpoint {
  // public static baseURL = `http://10.96.39.59:8181`;
  // public static baseURL = `http://10.96.65.46:8181`;
  // public static oauthBaseURL = `http://10.96.39.59:8003`;
  // public static baseURL = `http://localhost:8181`;
  // public static oauthBaseURL = `http://192.168.200.26:8003`;
  //prod live
  // public static baseURL = `http://103.219.114.181:8181`;
  // public static oauthBaseURL = `http://103.219.114.181:8003`;
  //prod domain
  // public static baseURL = `https://aml360.bkash.com:8181`;
  // public static oauthBaseURL = `https://aml360.bkash.com:8003`;
  //local lb
  // public static baseURL = `http://2323-aml360.grosvnerdata.com`;
  // public static oauthBaseURL = `http://2424-aml360.grosvnerdata.com`;
  //prod lb
  //  public static baseURL = `https://2525-aml360.bkash.com`;
  //  public static oauthBaseURL = `https://2323-aml360.bkash.com`;
  // ---------------Bkash Production configuration ----------------------------
  //  public static baseURL = `https://2525-aml360.bkash.com`;
  //  public static trainingServiceURL = ApiEndpoint.baseURL;
  //  public static oauthBaseURL = `https://2323-aml360.bkash.com`;
  // ---------------Bkash UAT configuration ----------------------------
  // public static baseURL = `http://10.96.38.34:8181`;
  // public static trainingServiceURL = `${ApiEndpoint.baseURL}`;
  // public static oauthBaseURL = `http://10.96.38.34:8003`;
  //--------------------------------------------------------------------
  // ---------------Development Server configuration ----------------------------
  // public static trainingServiceURL = `http://localhost:8585`;
  // public static oauthBaseURL = `http://localhost:8002`;
  //--------------------------------------------------------------------
 //public static baseURL = `http://192.168.2.173:8181`;
 // public static baseURL = `http://192.168.1.145:8181`;
 public static baseURL = environment.baseURL;
  public static fcaURL = environment.fcaURL;
 public static app1 = environment.app1;
 public static app2 = environment.app2;
  public static fcaapp1 = environment.fcaapp1;
  public static fcaapp2 = environment.fcaapp2;
 // public static baseURL = `http://182.163.112.206:8181`;
 //public static baseURL = `http://192.168.7.133:8181`;
 // public static baseURL = `http://localhost:8181`;
 //  public static baseURL = `http://localhost:8181`;
 public static queryServiceURL = environment.baseURL;
 public static eaServiceURL = environment.eaapp;
 //public static queryServiceURL = `http://192.168.2.130:8181`;
  //public static baseURL = `http://192.168.4.73:8181`;
  public static trainingServiceURL = environment.baseURL;
  //public static queryServiceURL = ApiEndpoint.baseURL;
 // public static oauthBaseURL = `http://182.163.112.206:8003`;
  public static oauthBaseURL = environment.oauthBaseURL;
  public static QUESTIONNAIRE_ENDPOINT = `${environment.fcaURL}/questionBank/`;
  public static PUBLISHED_QUESTIONNAIRE_ENDPOINT = `${environment.fcaURL}/publishedQuestionBank/`;
  public static ASSESSE_ENDPOINT = `${environment.fcaURL}/Assessee/`;
  public static OAUTH_TOKEN = `${environment.oauthBaseURL}/authenticate`;
  // public static OAUTH_TOKEN = `${ApiEndpoint.oauthBaseURL}/oauth/token`;
  public static OAUTH_REFRESH = `${ApiEndpoint.oauthBaseURL}/refresh`;
  public static fileServerBaseURL = `${environment.baseURL}/file/download?filePath`;
}
